import HttpBackend from 'i18next-http-backend';
import { path, mergeDeepRight } from 'ramda';
import fallback from './translations/fallback.js';

export default class I18nOCCOBackend {
  static type = 'backend';

  init(services, backendOptions = {}, i18nextOptions = {}) {
    this.services = services;
    this.options = backendOptions;
    this.i18nextOptions = i18nextOptions;

    this.orgBackend = new HttpBackend();

    // All translations are now stored at org level only
    this.orgBackend.init(
      services,
      {
        loadPath: `${backendOptions.cdn}/${backendOptions.orgId}/${backendOptions.projectName}/{{lng}}/{{ns}}.json`,
      },
      i18nextOptions
    );
  }

  read(language, namespace, callback) {
    const { eventCode } = this.options;

    this.orgBackend.read(language, namespace, (err, data) => {
      let orgData = data;
      if (err) {
        console.warn('[I18nOCCOBackend] Failed to read from org source:', err);
        orgData = {};
      }

      const fallbackData = path([this.options.projectName, language, namespace], fallback) || {};

      // Transform nested structure to flat key-value pairs
      // Structure: { "key": { "value": "org-level", "eventCode1": "event-specific" } }
      const transformedOrgData = Object.entries(orgData || {}).reduce((acc, [key, val]) => {
        const resolvedValue = eventCode && val[eventCode] !== undefined ? val[eventCode] : val.value;

        if (resolvedValue === undefined) {
          return acc;
        }

        // Use event-specific value if exists, otherwise use org-level value
        acc[key] = resolvedValue;
        return acc;
      }, {});

      const merged = mergeDeepRight(fallbackData, transformedOrgData);

      callback(null, merged);
    });
  }
}
